import { render, staticRenderFns } from "./tablehead.vue?vue&type=template&id=fa2fd450&"
import script from "./tablehead.vue?vue&type=script&lang=js&"
export * from "./tablehead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports